<template>
  <v-dialog :value="value" max-width="500px" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>Analytics Settings</v-card-title>

      <v-card-text class="pt-2">
        <v-switch
          :input-value="show_zero_values"
          label="Show cards with zero values"
          class="mt-0"
          hide-details
          @change="$emit('update:show_zero_values', $event)"
        />

        <slot name="additional-settings" />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="close">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AnalyticsSettingsDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    show_zero_values: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    close() {
      this.$emit('input', false);
    },
  },
};
</script>
